export function DisplayTime({ timezone, is24hFormat, currentTime }) {
  const formatString = is24hFormat ? 'HH:mm' : 'h:mma';

  return (
    <>
      {currentTime.tz(timezone).format(formatString)}
    </>
  );
}